import React, {Component} from 'react';
import PropTypes from 'prop-types';
import PlanItem from "./PlanItem";
import './PlanItemListManaged.css';

export default class PlanItemListManaged extends Component {
    handleTaskChecked(task, isComplete) {
        this.props.onTaskChecked(task, isComplete);
    }

    handleTaskClick(task) {
        if (this.props.onTaskClick) {
            this.props.onTaskClick(task);
        }
    }

    handleTaskDeleteClick(task) {
        this.props.onTaskDeleteClicked(task);
    }

    render() {
        if (!this.props.tasks || !this.props.tasks.length) {
            return (null);
        }

        let items = [];

        for (let i = 0; i < this.props.tasks.length; i++) {
            let task = this.props.tasks[i];

            items.push(
                <PlanItem task={task} key={`pt-${task.id}`}
                          onTaskChecked={this.handleTaskChecked.bind(this, task)}
                          onTaskClick={this.handleTaskClick.bind(this, task)}
                          onDeleteClicked={this.handleTaskDeleteClick.bind(this, task)}
                          seedMode={this.props.seedMode}
                          hideCompletion={this.props.hideCompletion}
                          hideControls={this.props.hideControls}
                />
            );
        }

        let classNames = ["PlanItemListManaged"];

        if (this.props.seedMode) {
            classNames.push("PlanItemListManaged--seed");
        }

        return (
            <div className={classNames.join(' ')}>
                {items}
            </div>
        );
    }
}

PlanItemListManaged.propTypes = {
    tasks: PropTypes.array.isRequired,
    onTaskClick: PropTypes.func,
    onTaskChecked: PropTypes.func.isRequired,
    onTaskDeleteClicked: PropTypes.func,
    seedMode: PropTypes.bool,
    dayMode: PropTypes.bool,
    hideCompletion: PropTypes.bool,
    hideControls: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/Portal/Planner/PlanItemListManaged.js